import '../../css/pages/basket-page.scss';
import * as DeliveryAccordion from '../modules/delivery-accordion/delivery-accordion';
import Carousel from '../modules/component-carousel/component-carousel';
import lazyHTML from '../modules/lazy-html/lazy-html';
import basketLines from '../modules/bag/basket-lines-ui';
import { addToBag } from '../modules/bag/bag-services';
import preventCheckout from "../modules/prevent-checkout/prevent-checkout";
import paypalIntegration from '../modules/paypal/paypal-basket';
import { customSelect } from '../modules/custom-select/custom-select';
import { modifyQty, handleLengthSelection, handleSizeSelection, updateQuantityOptions } from '../modules/bag/bag-services';
import { displayToast } from '../modules/toastify/toastify';
import { setupAdyen, destroyAdyen } from '../modules/adyen/adyen-ui';
import { bookAppointmentSlideout } from '../modules/book-appointment-slideout/book-appointment-slideout';
import { closePanel, openPanel, updatePanel } from '../modules/slideout-panel/slideout-panel';
import { fetchText } from './../modules/fetch-helper/fetch-helper';
import { setCookie, getCookie } from '@remarkablenet/rcm-utils/cookies';
import { gtag } from '../modules/utility-functions/utility-functions';
import { scrollIntoView } from '../modules/scroll-into-view/scroll-into-view';
import { addDelegateEventListener } from '@remarkablenet/rcm-utils/add-delegate-event-listener';

function init() {
    console.log("You are on the basket page");

    DeliveryAccordion.autoInitialise(() => {
        destroyAdyen();
        setupAdyen();
        window.setupAdyen = setupAdyen;
    });

    Carousel();
    lazyHTML();
    handleBackButtonNavigation();
    basketLines();
    preventCheckout();
    customSelect(document, onCustomSelectBasketChange);
    paypalIntegration();
    toggleRemoveCheck();
    updateQuantityOptions();
    bookAppointmentSlideout();
    deliveryOptionsTracking();
    scrollToDeliveryContainer();
    editBasketInfo();
    gpayContainerClickDetection();

    const cookie = getCookie({ name: 'isEmmb' });
    if (!cookie) {
        setupIdleTimer(20000);
    }

    const productCodes = document.querySelectorAll<HTMLInputElement>('[data-code]');
    if (productCodes.length > 0) {
        const codes = [];
        productCodes.forEach((code) => {
            codes.push(code.dataset.code);
        });
    }
}

// add to bag
const atbButton = document.querySelector('.js-basket-add-to-bag');

atbButton?.addEventListener("click", (e) => {
    e.preventDefault();

    const button = e.currentTarget as HTMLButtonElement;

    const productId = button.dataset.productid;
    const productSize = button.dataset.stockid;
    const productQuantity = Number(button.dataset.qty);

    const originalText = button.textContent;
    const width = button.offsetWidth;
    button.style.width = `${width}px`;
    button.disabled = true;

    addToBag({
        ...{ productId, stockId: productSize, quantity: productQuantity }
    }, false).then((data) => {
        if (data.success !== false) {
            button.textContent = "Adding to bag";
            window.location.reload();
            return;
        }

        button.textContent = originalText;
        button.disabled = false;
        displayToast(data.reason != null ? data.reason : data.message);
    }).catch(() => {
        button.textContent = originalText;
        button.style.width = "";
        button.disabled = false;
    });
});

const gpayContainerClickDetection = () => {
    const container = document.getElementById('google-pay-basket-container');
    if (container) {
        container.addEventListener('click', () => document.body.classList.add('gpay-container-open'), true);
    }
};

let idleTimer = null;

function setupIdleTimer(idleTime: number) {
    function handleActivity() {
        resetTimer();
    }

    function resetTimer() {
        if (document.body.classList.contains('gpay-container-open')) {
            document.body.classList.remove('gpay-container-open');
        }

        if (idleTimer) {
            clearTimeout(idleTimer);
        }

        idleTimer = setTimeout(() => {
            console.log(`User has been idle for ${idleTime / 1000} seconds.`);

            if (!document.body.classList.contains('gpay-container-open')) {
                triggerEMMB();
            }
        }, idleTime);
    }

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('scroll', handleActivity);

    resetTimer();
}

const editBasketInfo = () => {
    const editInfoButtons = document.querySelectorAll<HTMLElement>('.edit-info');
    const expanders = document.querySelectorAll<HTMLElement>('.edit-expander');

    if (editInfoButtons.length > 0 && expanders.length > 0) {
        editInfoButtons.forEach((button, i) => {
            button.addEventListener('click', () => {
                const expander = expanders[i];
                if (expander) {
                    if (expander.classList.contains('expanded')) {
                        expander.classList.remove('expanded');
                    } else {
                        expander.classList.add('expanded');
                    }
                }
            });
        });
    }
};

const triggerEMMB = () => {
    const cookie = getCookie({ name: 'isEmmb' });
    if (cookie) return;
    setCookie({ name: 'isEmmb', value: '0', days: 10 });

    openPanel('EmailMeMyBag', emailMeMyBag());
};

const emailMeMyBag = () => {
    console.log('Open Email Me My Bag Panel');

    const url = `/basket/emailmemybag`;
    const data = fetchText(url, null);

    data.then(data => {
        updatePanel('EmailMeMyBag', data);
        setUpBagListener();
    });
};

const scrollToDeliveryContainer = (): void => {
    const headingWithinBasket = document.querySelector('.basket-container__delivery .heading') as HTMLElement | null;
    const paymentOptionsDisabled = document.querySelector('.payment-options-disabled') as HTMLElement | null;

    if (headingWithinBasket && paymentOptionsDisabled) {
        addDelegateEventListener({
            container: document,
            event: 'click',
            target: '.payment-options-disabled',
            callback: () => {
                scrollIntoView(headingWithinBasket, { scrollUp: 32, scrollDown: 32 });
            }
        });
    }
};

const setUpBagListener = () => {
    const form = document.querySelector('.js-emmb-form') as HTMLFormElement;
    const btn = document.querySelector('.js-submit-emmb') as HTMLElement;
    const inputs = document.querySelectorAll('.js-emmb-form .form-group input') as NodeList;

    if (form) {
        btn.addEventListener('click', async (e) => {
            e.preventDefault();

            const data = new FormData(form);
            let inputCheck = true;

            inputs.forEach((input) => {
                if ((input as HTMLInputElement).value.trim() === '') {
                    inputCheck = false;
                }
            });

            if (inputCheck === true) {
                let object = {};
                data.forEach((value, key) => object[key] = value);

                const fetchResponse = await fetch(`/basket/basket/sendbaskettoemail`, {
                    method: 'post',
                    body: data,
                });

                const responseText = await fetchResponse.text();

                if (responseText === 'Success') {
                    form.classList.add("d-none");
                    document.querySelector('.emmb-status-block').classList.remove("d-none");

                    setTimeout(() => {
                        closePanel('EmailMeMyBag');
                    }, 4000);
                }
            } else {
                displayToast('Name and email must not be empty', {
                    className: 'toastify-center typography-apercu-mono font-regular alert-danger',
                    backgroundColor: "#d9534f",
                    duration: 3000
                });
            }
        });
    }
};

const exit = () => {
    console.log("Basket page: Exit");
};

const handleBackButtonNavigation = () => {
    if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD)
        window.location.reload();
};

const toggleRemoveCheck = () => {
    document.querySelectorAll('.js-basket-item-remove-check').forEach(element => {
        element.addEventListener('click', () => {
            const container = element.closest('.basket-item__meta');
            const clickDelete = container.querySelector('.basket-item__remove');
            const deleteCheck = container.querySelector('.basket-product__item-delete');
            const val = container.querySelector('.pricing-block__price span').textContent;
            const code = element.closest('.basket-item').getAttribute('data-code');
            const title = container.querySelector('.basket-item__title').textContent.trim();

            clickDelete.classList.toggle('d-none');
            deleteCheck.classList.toggle('d-none');

            gtag('event', 'remove_from_cart', {
                'value': val,
                'item_id': code,
                'item_name': title
            });
        });
    });

    document.querySelectorAll('.js-decline-remove').forEach(element => {
        element.addEventListener('click', () => {
            const container = element.closest('.basket-item__meta');
            const removeCheck = container.querySelector('.basket-product__item-delete');
            const removeBtn = container.querySelector('.basket-item__remove');

            removeCheck.classList.toggle('d-none');
            removeBtn.classList.toggle('d-none');
        });
    });
};

async function onCustomSelectBasketChange({ name, gid, value, extraAttributes, hasChanged, parent }) {
    if (name === "Length" && hasChanged) {
        const selectorValue = value === "R" ? "SizeRegular" : value === "L" ? "SizeLong" : value === "XL" ? "SizeExtra Long" : "SizeShort";
        handleLengthSelection(gid, selectorValue, parent);
    }

    if ((name !== "Length" && name !== "Qty") && hasChanged) {
        if (value == "--") {
            return;
        }
        const quantityElement = document.querySelector<HTMLInputElement>(`[data-name="Qty"][data-gid="${gid}"] input`);
        const qty = quantityElement.value.split('Qty:');

        const length = document.querySelector<HTMLInputElement>(`[data-name="Length"][data-gid="${gid}"] input`);
        let lengthValue = length?.value;
        if (length?.value.length == 1) {
            lengthValue = length?.value === "R" ? "Regular" : length?.value === "L" ? "Long" : length?.value === "XL" ? "Extra Long" : "Short";
        }

        var size = document.querySelector<HTMLInputElement>(`[data-name="${name === "Size" + lengthValue ? 'Size' + lengthValue : lengthValue}"][data-gid="${gid}"] input`);
        if (name === "Size") {
            size = document.querySelector<HTMLInputElement>(`[data-name="${name === "Size" ? 'Size' : lengthValue}"][data-gid="${gid}"] input`);
        }

        handleSizeSelection(extraAttributes.id, qty[1], length?.value, size.value, parent);
    }

    if (name == "Qty" && hasChanged) {
        if (extraAttributes.id) {
            var response = await modifyQty(extraAttributes.id, value);
        }

        if (response.success) {
            location.reload();
        } else {
            displayToast(response.errors[0].description, {
                className: 'toastify-center typography-apercu-mono font-regular alert-danger',
                backgroundColor: "#d9534f",
                duration: 5000
            });
        }
    }
}

const deliveryOptionsTracking = () => {
    const deliveryOptions = document.querySelector<HTMLElement>('.delivery-options');

    if (deliveryOptions) {
        deliveryOptions.addEventListener("click", (event) => {
            const clickedElement = event.target as HTMLElement;
            let option = clickedElement.getAttribute('data-delivery-option');

            if (clickedElement.classList.contains("delivery-option-el")) {
                const parentElement = clickedElement.closest('.js-accordion-option');
                if (parentElement) {
                    option = parentElement.getAttribute('data-delivery-option');
                    gtag('event', 'delivery_option_selected', {
                        'delivery_option': option
                    });
                }
            }
        });
    }
};

window.basketPage = {
    init,
    exit,
    triggerEMMB
};